import messages from '../../../../messages';

export const DEFAULTS = {
  image: null,
  title: '',
  description: '',
  button_label: '',
  button_link: null,
  full_width: false,
  copyright_text: '',
};

const Schema = (props) => ({
  title: 'FCMH Header',
  fieldsets: [
    {
      id: 'default',
      title: 'Inhalt',
      fields: [
        'image',
        'copyright_text',
        'title',
        'description',
        'button_label',
        'button_link',
        'full_width',
      ],
    },
  ],
  properties: {
    image: {
      title: props.intl.formatMessage(messages.headerBackgroundImage),
      widget: 'object_browser',
      mode: 'image',
    },
    copyright_text: {
      title: 'Bildnachweis',
      description:
        'Wird als ©-Tooltip im Headerbild angezeigt (manuell eintragen).',
      type: 'string',
      widget: 'textarea',
      default: DEFAULTS.copyright_text,
    },
    title: {
      title: props.intl.formatMessage(messages.headerTitle),
      type: 'string',
      default: DEFAULTS.title,
    },
    description: {
      title: props.intl.formatMessage(messages.headerDescription),
      widget: 'textarea',
      default: DEFAULTS.description,
    },
    button_label: {
      title: 'Button Text',
      type: 'string',
      default: DEFAULTS.button_label,
    },
    button_link: {
      title: 'Button Link',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
      description: props.intl.formatMessage(messages.listingFootnote),
    },
    full_width: {
      title: props.intl.formatMessage(messages.fullWidth),
      type: 'boolean',
      default: false,
    },
  },
  required: ['title'],
});

export default Schema;
